import { fetch } from '@atlassian/eoc-fetch';

import type {
	GetUserRightsResponse,
	UserAccessRights,
} from '../../../common/types/user-access-rights';
import { UrlHelper } from '../../../common/utils/url-helper';

export const getUserRights = (teamId?: string | null): Promise<UserAccessRights> => {
	return fetch<GetUserRightsResponse>(
		UrlHelper(`/v3/integrations/unified/rights`, {
			teamId,
		}),
	).then((response) => response.data);
};
